// External libraries
import React, { useState } from 'react';
import { useStoreState } from 'easy-peasy';
import { func } from 'prop-types';

// Internal modules
import { $logger } from '@/lib/logger';
import { features, getLocale } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { NationalitySelectBox } from './NationalitySelectBox';
import { NationalityContainer, NationalityText } from './Components';

const Nationality = props => {
  useMountLogging('Nationality');
  const hasAddress = features.isNotActive('isAddressless');
  const [shouldShowSelectBox, setShouldShowSelectBox] = useState(hasAddress);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const selectOptions = useStoreState(({ api }) => {
    const { locale } = getLocale();
    return api.griffinMetadata.territories[locale];
  });

  return (
    <NationalityContainer isFirstField={!hasAddress}>
      {shouldShowSelectBox ? (
        <NationalitySelectBox
          disabled={isFormSubmitting}
          selectOptions={selectOptions}
          shouldFocusOnRender={!hasAddress}
          {...props}
        />
      ) : (
        <NationalityText
          clickHandler={() => {
            $logger.fpti('weasley_change_nationality', {
              state_name: 'signup',
              transition_name: 'prepare_show_nationality_options',
            });
            setShouldShowSelectBox(true);
          }}
          isFormSubmitting={isFormSubmitting}
          options={selectOptions}
        />
      )}
    </NationalityContainer>
  );
};

Nationality.propTypes = {
  blurHandler: func.isRequired,
  changeHandler: func.isRequired,
};

export { Nationality };
